import { css } from "styled-components";

export const ResetCss = css`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    scroll: auto;
  }

  ::-webkit-scrollbar-track {
    background-color: transparent;
  }
  ::-webkit-scrollbar-thumb {
    background-color: var(--scroll-color);
    border-radius: 1.25rem;
    border: 0.375rem solid transparent;
    background-clip: content-box;
  }

  body {
    font-weight: 500;
  }

  img {
    display: block;
  }
`;
